import '../../../shared/js/utils/polyfills';

export class AmountSelector {
    constructor(element, options = {}) {
        this.element = element;
        this.valueLayerElement = this.element.querySelector('.amount-selector__select-layer');
        this.step = options.step || 1;
        this.min = options.min || 0;
        this.max = options.max || 5;
        this.onChange = options.onChange || null;
        this.value = options.value || null;
    }

    render() {
        const that = this;
        this.hoverHandler = function (event) {
            that.valueLayerElement.style.width = that.calculateProportionalValue(event.offsetX) * 100 + '%';
        };

        if (this.value === null) {
            this.element.addEventListener('mousemove', this.hoverHandler);
        } else {
            this.valueLayerElement.style.width = this.calculatePercentageFromValue() + '%';
        }

        this.element.addEventListener('click', (event) => {
            this.valueLayerElement.style.width = this.calculateProportionalValue(event.offsetX) * 100 + '%';
            const value = this.calculateAbsoluteValue(event.offsetX);

            if (this.value === value) {
                this.value = null;
                this.element.addEventListener('mousemove', this.hoverHandler);
            } else {
                this.value = value;
                this.element.removeEventListener('mousemove', this.hoverHandler);
            }

            if (typeof this.onChange === 'function') {
                this.onChange(this.value);
            }
        });

        this.element.addEventListener('mouseleave', () => {
            if (this.value === null) {
                this.valueLayerElement.style.width = null;
            }
        });
    }

    calculateProportionalValue(offset) {
        const range = this.max - this.min;
        const proportionalValue = offset / this.element.offsetWidth;
        const proportionalStep = this.step / range;

        return Math.ceil(proportionalValue / proportionalStep) * proportionalStep;
    }

    calculateAbsoluteValue(offset) {
        const range = this.max - this.min;

        // Zaokrouhleno
        return Math.round(this.calculateProportionalValue(offset) * range) + this.min;
    }

    calculatePercentageFromValue() {
        const range = this.max - this.min;

        return ((this.value - this.min) / range) * 100;
    }
}
